export const registryKeys = {
  usersAll: ['REGISTRY_USERS'] as const,
  users: (size: number) => ['REGISTRY_USERS', { size }],
};
